"use strict";

const DocsController = function ($scope, DocsLinksService) {
    const vm = this;
    vm.docLinks = DocsLinksService;
};

DocsController.$inject = ["$scope", "DocsLinksService"];
export default DocsController;
